import {
	type Dtos,
	getBaseNaicsCode,
	type NAICSCodeGroupMap,
	NaicsCodeKind,
	naicsCodeSchema,
} from "@inrev/common";
import { Option } from "@inrev/core";

export const buildNaicsCodeGroupMap = (rows: Dtos.NaicsCode.List.Response): NAICSCodeGroupMap => {
	const byId = new Map(rows.map((row) => [row.id, row]));
	const groupMap: NAICSCodeGroupMap = new Map();

	for (const row of rows) {
		if (row.kind !== NaicsCodeKind.detail_item) continue;
		const parsed = naicsCodeSchema.safeParse(row.code);
		if (!parsed.success) continue;

		const parent = Option.isSome(row.parentId) ? byId.get(row.parentId) : undefined;
		const groupKey = getBaseNaicsCode(row.code);
		const groupLabel = parent?.label ?? row.label;
		const entry = { code: parsed.data, label: row.label };
		const existing = groupMap.get(groupKey);
		if (existing) {
			existing.subCodes.set(row.id, entry);
		} else {
			groupMap.set(groupKey, {
				label: groupLabel,
				subCodes: new Map([[row.id, entry]]),
			});
		}
	}

	return groupMap;
};
